"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyLog = void 0;
const prettyLog = (value, conditional = true) => {
    conditional && console.log(JSON.stringify(value, null, 2));
};
exports.prettyLog = prettyLog;
//# sourceMappingURL=logging.js.map